import { Reducer } from 'react';
import {
  TransactionsDropzoneActionTypes,
  TransactionsDropzoneState,
} from 'store/transactionDropzone/transactionDropzoneTypes';
import * as actionTypes from 'constants/action-types';
import { GenericDsl } from 'types/rest/dslTypes';

const initialState: TransactionsDropzoneState = {
  modalIsOpen: false,
  dslResponses: [],
  transactions: [],
};

export const TransactionsDropzoneReducer: Reducer<TransactionsDropzoneState, TransactionsDropzoneActionTypes> = (
  state = initialState,
  action,
): TransactionsDropzoneState => {
  switch (action.type) {
    case actionTypes.TOGGLE_MODAL:
      return {
        ...state,
        modalIsOpen: !state.modalIsOpen,
      };
    case actionTypes.APPEND_DSL_TO_ARRAY:
      const responses: GenericDsl[] = [...state.dslResponses, ...action.payload];
      return {
        ...state,
        dslResponses: responses,
      };

    case actionTypes.RESET_STORE_STATE:
      return {
        ...state,
        modalIsOpen: false,
        dslResponses: [],
      };

    default:
      return state;
  }
};
